import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Layers, RockBottomLayers} from "./RockBottomLayers";
import {RockBottom} from "../RockBottom";
import {TimelineLite, TweenLite} from "gsap";
import {MathHelper} from "../../core/utils/MathHelper";

export class RockBottomForeground extends PIXI.Container {
    private _layer: StageLayer | undefined;
    private _paperSpines: PIXI.spine.Spine[] = [];
    private _flyAnims: string[] = ["Left_To_Right_Mid", "Left_To_Right_Top", "Right_To_Left_Bottom", "Right_To_Left_Top"];
    private _mainTl: TimelineLite | null;

    constructor() {
        super();
        this.init();
    }

    public stopPaperFlyAnimation(): void {
        if (!RockBottom.inBonusGame) {
            for (let i: number = 0; i < this._flyAnims.length; i++) {
                TweenLite.to(this._paperSpines[i], {
                    alpha: 0,
                    duration: 0.3,
                    onComplete: () => {
                        this.resetSpine(this._paperSpines[i]);
                    }
                })
            }

            if (this._mainTl) {
                this._mainTl.paused();
                this._mainTl.kill();
                this._mainTl = null;
            }
        }
    }

    public playPaperFlyAnimation(): void {
        if (!RockBottom.inBonusGame && !(RockBottom.autoPlayPlugin.isAutoplayRound)) {
            this.stopPaperFlyAnimation();
            this._mainTl = new TimelineLite({paused: true, repeat: -1, repeatDelay: this.getRandomDelay()});
            this._mainTl.add(TweenLite.to(this, {
                duration: 0.1,
                delay: this.getRandomDelay(),
                onStart: () => {
                    const spineToPlay: PIXI.spine.Spine = this.getRandomSpine(),
                        animIdx: number = this._paperSpines.indexOf(spineToPlay);

                    spineToPlay.state.setAnimation(0, this._flyAnims[animIdx], false);
                    spineToPlay.visible = true;
                    spineToPlay.alpha = 1;
                }
            }));
            this._mainTl.play(0);
        }
    }

    private getRandomDelay(): number {
        return MathHelper.randomNumberInRange(3, 10);
    }

    private getRandomSpine(): PIXI.spine.Spine {
        const randomIdx: number = MathHelper.uniqueNumberInRange(0, this._flyAnims.length - 1);
        return this._paperSpines[randomIdx];
    }

    private init(): void {
        this._layer = RockBottomLayers.getLayer(Layers.FOREGROUND);
        this.createPaperAnim();
        this._layer?.addChild(this);
    }

    private createPaperAnim(): void {
        for (let i: number = 0; i < this._flyAnims.length; i++) {
            const spineAnim: PIXI.spine.Spine = new PIXI.spine.Spine(RockBottom.assetLoader.getSpineAsset("Paper_Fly"));
            let spinePos: PIXI.Point,
                scaleX: number = 1;

            if (i === 0) {
                spinePos = new PIXI.Point(500, 470);
            } else if (i === 1) {
                spinePos = new PIXI.Point(-330, 500);
                scaleX = -1;
            } else if (i === 2) {
                spinePos = new PIXI.Point(260, 260);
            } else if (i === 3) {
                spinePos = new PIXI.Point(440, 360);
                scaleX = -1;
            } else {
                spinePos = new PIXI.Point(360, 360);
            }

            spineAnim.position.set(spinePos.x, spinePos.y);
            spineAnim.scale.set(scaleX, 1);
            this._paperSpines.push(spineAnim);
            this.addChild(spineAnim);
        }
    }

    private resetSpine(currSpine: PIXI.spine.Spine): void {
        currSpine.skeleton.setToSetupPose();
        currSpine.updateTransform();
        currSpine.visible = false;
        currSpine.alpha = 0;
    }
}